import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/ai-worker-removebg.png";

import { useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../services/oprations/authAPI";

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.profile);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout(navigate));
  };

  // Get user initials
  const getInitials = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  return (
    <header className="fixed top-0 left-0 w-full bg-white/90 backdrop-blur-xl z-50 border-b border-white/30 shadow-sm">

      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-4">
          <div
            className="flex items-center space-x-2 cursor-pointer"
            onClick={() => navigate("/")}
          >
            <img
              src={logo}
              alt="Logo"
              width={180}
              height={40}
              className="object-contain"
            />
          </div>
        </div>

        {/* Desktop Navigation Links */}
        <div className="hidden md:flex items-center space-x-10 font-medium">
          {[
            { label: "Chat bots", path: "/dashboard" },
            { label: "Assistant", path: "/dashboard/ai-assistants" },
            { label: "Vector Stores", path: "/dashboard/vector-stores" },
            { label: "AI Program", path: "/dashboard/ai-programs" },
          ].map((item) => (
            <button
              key={item.label}
              onClick={() => navigate(item.path)}
              className="
            relative text-slate-800
            transition-all duration-300
            hover:text-slate-900
            hover:font-semibold
            after:absolute after:left-0 after:-bottom-1
            after:h-[2px] after:w-0 after:bg-cyan-500
            after:transition-all after:duration-300
            hover:after:w-full
          "
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* Profile Dropdown */}
        <div className="relative hidden md:flex items-center">
          <button
            onClick={() => setDropdownOpen((prev) => !prev)}
            className="
          w-10 h-10 rounded-full
          bg-white text-slate-800
          flex items-center justify-center
          font-semibold uppercase
          border border-white/40
          shadow-md
          hover:shadow-cyan-400/40
          transition-all duration-300
        "
          >
            {getInitials(user?.name)}
          </button>

          {dropdownOpen && (
            <div className="absolute right-0 top-full mt-3 w-56 bg-white/95 backdrop-blur-xl rounded-xl shadow-xl border border-white/30 py-3 z-50 animate-fadeIn">
              <div className="px-4 pb-3 border-b border-slate-200">
                <p className="text-sm font-semibold text-slate-800">
                  {user?.name}
                </p>
                <p className="text-xs text-slate-500">{user?.email}</p>
              </div>
              <button
                onClick={handleLogout}
                className="w-full text-left px-4 py-2 text-sm text-red-500 hover:bg-red-50 transition-colors"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
